export default __webpack_public_path__ + "static/media/photo--sm--hockey7.7101b00f.jpg";